/* Gaia shower filter sales page (gsp-*) behaviour */
(() => {
  if (window.__gspLoaded) return;
  window.__gspLoaded = true;

  const BLOCKED_PLAN_IDS = ['689378787664']; // matches upcart-smartrr-fix.js
  const isAddon = (s) => /add-?on/i.test(s || '');

  function formatMoney(cents, format) {
    const fmt = format || '€{{amount}}';
    const num = (n, dec, thou, decSep) => {
      const fixed = (n / 100).toFixed(dec);
      const [i, d] = fixed.split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? decSep + d : '');
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return num(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return num(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(cents, 2, "'", '.');
        default: return num(cents, 2, ',', '.');
      }
    }).replace(/<[^>]*>/g, '');
  }

  function initBuyBox(root) {
    const dataEl = root.querySelector('[data-gsp-data]');
    if (!dataEl) return;
    let data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

    const ci = data.colorIndex;
    const colorBtns = [...root.querySelectorAll('[data-gsp-color]')];
    const planBtns = [...root.querySelectorAll('[data-gsp-plan]')];
    const atc = root.querySelector('[data-gsp-atc]');
    const errorEl = root.querySelector('[data-gsp-error]');
    const mainImg = root.querySelector('.gsp-buy__main img');
    const badge = root.querySelector('[data-gsp-badge]');
    const thumbs = root.querySelector('[data-gsp-thumbs]');
    const bar = root.querySelector('[data-gsp-bar]');

    const firstAvail = data.variants.find((v) => v.available) || data.variants[0];
    const state = {
      color: ci > -1 && firstAvail ? firstAvail.options[ci] : null,
      plan: Math.min(Math.max((parseInt(root.dataset.defaultPlan, 10) || 1) - 1, 0), Math.max(planBtns.length - 1, 0)),
      img: 0
    };

    const variantFor = (color) => {
      if (ci < 0) return firstAvail;
      const matches = data.variants.filter((v) => v.options[ci] === color);
      return matches.find((v) => v.available) || matches[0] || firstAvail;
    };

    const sellingPlanFor = (btn, variant) => {
      if (btn.dataset.type !== 'subscription') return null;
      const allocated = (p) => variant && Object.prototype.hasOwnProperty.call(variant.allocations, String(p.id));
      const match = (btn.dataset.match || '').trim().toLowerCase();
      let plans = data.plans.filter(allocated);
      if (match) {
        return plans.find((p) => p.name.toLowerCase().includes(match) || p.group.toLowerCase().includes(match)) || null;
      }
      plans = plans.filter((p) => !BLOCKED_PLAN_IDS.includes(String(p.id)) && !isAddon(p.name) && !isAddon(p.group));
      return plans[0] || null;
    };

    const priceFor = (btn, variant) => {
      const qty = parseInt(btn.dataset.qty, 10) || 1;
      const plan = sellingPlanFor(btn, variant);
      const unit = plan ? variant.allocations[String(plan.id)] : variant.price;
      const was = Math.max(variant.compareAt || 0, variant.price) * qty;
      return { qty, plan, now: unit * qty, was: was > unit * qty ? was : 0 };
    };

    const galleryFor = (color) => {
      const v = variantFor(color);
      const list = [];
      if (v && v.image) list.push({ src: v.image, thumb: v.thumb });
      const key = (color || '').toLowerCase();
      data.gallery.filter((g) => g.src && (!g.color || g.color === key)).forEach((g) => list.push(g));
      if (list.length < 2) data.productImages.forEach((g) => { if (!list.some((x) => x.src === g.src)) list.push(g); });
      return list.slice(0, 5);
    };

    function renderGallery() {
      const list = galleryFor(state.color);
      const current = list[state.img] || list[0];
      if (mainImg && current) {
        mainImg.removeAttribute('srcset');
        mainImg.src = current.src;
      }
      if (badge && state.color) badge.textContent = state.color;
      if (!thumbs) return;
      thumbs.innerHTML = '';
      if (list.length < 2) return;
      list.forEach((g, i) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'gsp-buy__thumb' + (i === state.img ? ' is-active' : '');
        b.setAttribute('aria-label', 'Show image ' + (i + 1));
        const im = document.createElement('img');
        im.src = g.thumb || g.src; im.alt = ''; im.loading = 'lazy';
        b.appendChild(im);
        b.addEventListener('click', () => { state.img = i; renderGallery(); });
        thumbs.appendChild(b);
      });
    }

    function render() {
      const variant = variantFor(state.color);
      if (planBtns[state.plan] && planBtns[state.plan].dataset.type === 'subscription' && !sellingPlanFor(planBtns[state.plan], variant) && !window.Shopify?.designMode) {
        const fallback = planBtns.findIndex((b) => b.dataset.type !== 'subscription' || sellingPlanFor(b, variant));
        if (fallback > -1) state.plan = fallback;
      }
      colorBtns.forEach((b) => {
        const on = b.dataset.gspColor === state.color;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        const avail = data.variants.some((v) => v.options[ci] === b.dataset.gspColor && v.available);
        b.disabled = !avail;
      });
      planBtns.forEach((b, i) => {
        const on = i === state.plan;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
        const p = priceFor(b, variant);
        const unavailable = b.dataset.type === 'subscription' && !p.plan;
        b.hidden = unavailable && !window.Shopify?.designMode;
        b.querySelector('[data-now]').textContent = formatMoney(p.now, data.moneyFormat);
        b.querySelector('[data-was]').textContent = p.was ? formatMoney(p.was, data.moneyFormat) : '';
      });
      const btn = planBtns[state.plan];
      const p = btn ? priceFor(btn, variant) : { now: variant.price };
      const label = variant.available ? `${data.atcLabel} – ${formatMoney(p.now, data.moneyFormat)}` : data.soldOut;
      if (atc) { atc.textContent = label; atc.disabled = !variant.available; }
      if (bar) {
        const cta = bar.querySelector('[data-gsp-bar-cta]');
        if (cta) cta.textContent = label;
        const c = bar.querySelector('[data-gsp-bar-color]');
        if (c) c.textContent = state.color;
        const pl = bar.querySelector('[data-gsp-bar-plan]');
        if (pl && btn) pl.textContent = btn.dataset.title;
        const im = bar.querySelector('[data-gsp-bar-img]');
        if (im && variant.thumb) im.src = variant.thumb;
      }
      renderGallery();
    }

    colorBtns.forEach((b) => b.addEventListener('click', () => { state.color = b.dataset.gspColor; state.img = 0; render(); }));
    planBtns.forEach((b, i) => b.addEventListener('click', () => { state.plan = i; render(); }));

    if (atc) atc.addEventListener('click', async () => {
      const variant = variantFor(state.color);
      const btn = planBtns[state.plan];
      const p = btn ? priceFor(btn, variant) : { qty: 1, plan: null };
      if (btn && btn.dataset.type === 'subscription' && !p.plan) {
        errorEl.textContent = 'This subscription option isn’t available for the selected finish.';
        errorEl.hidden = false;
        return;
      }
      errorEl.hidden = true;
      atc.disabled = true;
      const item = { id: variant.id, quantity: p.qty };
      if (p.plan) item.selling_plan = p.plan.id;
      try {
        const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [item] })
        });
        const json = await res.json();
        if (!res.ok) throw new Error(json.description || json.message || 'Could not add to cart');
        const root_ = window.Shopify?.routes?.root || '/';
        if (data.afterAdd === 'checkout') { window.location.href = root_ + 'checkout'; return; }
        if (data.afterAdd === 'cart') { window.location.href = root_ + 'cart'; return; }
        const cart = await (await fetch(root_ + 'cart.js')).json();
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart } }));
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.show === 'function') {
          setTimeout(() => drawer.show(), 150);
        } else if (!document.querySelector('[id*="upcart"], upcart-drawer')) {
          window.location.href = root_ + 'cart';
        }
      } catch (e) {
        errorEl.textContent = e.message;
        errorEl.hidden = false;
      } finally {
        atc.disabled = false;
        render();
      }
    });

    // Dispatch countdown
    const timer = root.querySelector('[data-gsp-timer]');
    if (timer) {
      const cutoffHour = parseInt(timer.dataset.cutoff, 10) || 14;
      const pad = (x) => String(x).padStart(2, '0');
      const tick = () => {
        const now = new Date();
        const cut = new Date(); cut.setHours(cutoffHour, 0, 0, 0);
        if (cut < now) cut.setDate(cut.getDate() + 1);
        const diff = cut - now;
        timer.textContent = `${pad(Math.floor(diff / 3.6e6))}:${pad(Math.floor(diff % 3.6e6 / 6e4))}:${pad(Math.floor(diff % 6e4 / 1e3))}`;
      };
      tick(); setInterval(tick, 1000);
    }

    // Sticky bar: visible after scrolling past the hero, hidden while the buy box is on screen
    if (bar) {
      let buyVisible = false;
      const heroCta = document.querySelector('.gsp-hero__cta');
      const update = () => {
        const past = heroCta ? heroCta.getBoundingClientRect().bottom < 0 : window.scrollY > 700;
        const show = past && !buyVisible;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        const cta = bar.querySelector('[data-gsp-bar-cta]');
        if (cta) cta.tabIndex = show ? 0 : -1;
      };
      new IntersectionObserver((entries) => { buyVisible = entries[0].isIntersecting; update(); }).observe(root.querySelector('.gsp-wrap'));
      window.addEventListener('scroll', update, { passive: true });
    }

    render();
  }

  function initReviews(root) {
    const more = root.querySelector('[data-gsp-more]');
    if (!more) return;
    const step = parseInt(more.dataset.step, 10) || 6;
    more.addEventListener('click', () => {
      const grid = root.querySelector('.gsp-reviews__grid');
      if (grid) grid.classList.add('is-expanded');
      const hidden = [...root.querySelectorAll('.gsp-review.is-hidden')];
      hidden.slice(0, step).forEach((r) => r.classList.remove('is-hidden'));
      if (hidden.length <= step) more.parentElement.hidden = true;
    });
  }

  const init = (scope) => {
    scope.querySelectorAll('[data-gsp-buy]').forEach(initBuyBox);
    scope.querySelectorAll('[data-gsp-reviews]').forEach(initReviews);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
